<template>
    <!-- Split button -->
    <div class="btn-group" v-if="hasActions">
        <button class="btn btn-primary dropdown-toggle" type="button" 
        id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" 
        aria-expanded="true">
            Actions
            <span class="caret"></span>
        </button>
        <ul class="dropdown-menu" >
            <li v-for="action in permActions">
                <router-link :to="action.url" >
                    {{ action.name }}
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex';
import store from '../store.js';

export default {
    props: {
        actions: { default: () => [] },
    },
    data () {
        return {}
    },
    computed: {
        permActions: function(state){
            return this.actions.filter(this.isPermitted);
        },
        hasActions: function(state){
            return this.permActions.length > 0;
        }
    },
    components: {
    },
    methods: {
        isPermitted: function(action){
            return store.getters.hasPerm(action.perm);
        },
    }
};
</script>
<style lang="scss" scoped>
@import "../css/constants";
.btn-group .btn{
  height: $p32;
}

.filter-container .dropdown-menu>li>a{
    font-weight: 600;
}

.dropdown-menu{
    background-color: white;
    border: 1px solid rgb(239, 239, 239);
}
</style>


// WEBPACK FOOTER //
// src/components/ActionList.vue